import {
  type BgColors,
  type BorderColors,
  ColorHex,
  type Colors,
} from '../../constants';
import type { ToastType } from './notifyCallbacks';

const textColor: Record<ToastType, Colors> = {
  info: 'text-ds-primary-500',
  success: 'text-ds-accent2-500',
  error: 'text-ds-danger-500',
  dark: 'text-ds-accent3-100',
  warning: 'text-ds-secondary-500',
};

const closeIconColor: Record<ToastType, (typeof ColorHex)[string]> = {
  success: ColorHex.accent2500,
  error: ColorHex.danger500,
  info: ColorHex.primary500,
  warning: ColorHex.secondary500,
  dark: ColorHex.accent3100,
};

const infoIconColor: Record<ToastType, (typeof ColorHex)[string]> = {
  success: ColorHex.accent2500,
  error: ColorHex.danger500,
  info: ColorHex.primary500,
  warning: ColorHex.secondary500,
  dark: ColorHex.accent3100,
};

const bgColor: Record<ToastType, BgColors> = {
  success: 'bg-ds-accent2-100',
  error: 'bg-ds-danger-100',
  info: 'bg-ds-primary-100',
  warning: 'bg-ds-secondary-100',
  dark: 'bg-ds-natural-600',
};

const borderColor: Record<ToastType, BorderColors> = {
  dark: 'border-ds-natural-600',
  error: 'border-ds-danger-100',
  warning: 'border-ds-secondary-100',
  info: 'border-ds-primary-100',
  success: 'border-ds-accent2-100',
};

export { textColor, infoIconColor, closeIconColor, borderColor, bgColor };
